import React from 'react';
import styled from 'styled-components';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

const Base = styled.div.withConfig({ componentId: 'sc-dxotyo-0' })`
  text-align: left;
  a {
    cursor: pointer;
    height: 17.5px;
    width: 17.5px;
    margin-left: 66px;
    &:first-child {
      margin-left: 0;
    }
  }
  a:visited {
    color: #dee6eb !important;
  }
`;

const Desktop = styled(Base).withConfig({ componentId: 'sc-dxotyo-1' })``;

const Mobile = styled(Base).withConfig({ componentId: 'sc-dxotyo-2' })`
  margin: 20px 0;
  a {
    margin-left: 24px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

type Props = {
  isMobile?: boolean;
};

const SocialMedia = ({ isMobile }: Props) => {
  return (
    <span>
      {isMobile ? (
        <Mobile>
          <a href="https://www.facebook.com/solvhealth">
            <img
              alt="facebook"
              loading="lazy"
              src="/images/icons/social/Icon-Facebook.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>

          <a href="https://twitter.com/solvhealth">
            <img
              alt="twitter"
              loading="lazy"
              src="/images/icons/social/Icon-Twitter.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>

          <a href="https://www.instagram.com/solvhealth">
            <img
              alt="instagram"
              loading="lazy"
              src="/images/icons/social/Icon-Instagram.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>
        </Mobile>
      ) : (
        <Desktop>
          <a href="https://www.facebook.com/solvhealth">
            <img
              alt="fb"
              loading="lazy"
              src="/images/icons/social/Icon-Facebook.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>

          <a href="https://twitter.com/solvhealth">
            <img
              alt="twitter"
              loading="lazy"
              src="/images/icons/social/Icon-Twitter.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>

          <a href="https://www.instagram.com/solvhealth">
            <img
              alt="instagram"
              loading="lazy"
              src="/images/icons/social/Icon-Instagram.svg"
              // @ts-expect-error ts-migrate(2322) FIXME: Property 'type' does not exist on type 'DetailedHT... Remove this comment to see the full error message
              type="social"
            />
          </a>
        </Desktop>
      )}
    </span>
  );
};

export default SocialMedia;
